<template>
	<v-dialog v-model="dialog" persistent max-width="500" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Detail Serial {{detailSerialMembership.serial_id}}</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12" class="pb-1">
							<div class="font-size-10 cl-grey">Digunakan Oleh</div>
							<div class="font-size-11 cl-primary font-weight-500">{{ detailSerialMembership.member_name ? detailSerialMembership.member_name : '-' }}</div>
						</v-col>
						<v-col cols="12" sm="6" class="pb-1">
							<div class="font-size-10 cl-grey">Email</div>
							<div class="font-size-11 cl-secondary font-weight-500">{{ detailSerialMembership.member_email ? detailSerialMembership.member_email : '-' }}</div>
						</v-col>
						<v-col cols="12" sm="6" class="pb-1">
							<div class="font-size-10 cl-grey">No. Handphone</div>
							<div class="font-size-11 cl-secondary font-weight-500">{{ detailSerialMembership.member_mobilephone ? detailSerialMembership.member_mobilephone : '-' }}</div>
						</v-col>
						<v-col cols="12" sm="6" class="pb-1">
							<div class="font-size-10 cl-grey">Tanggal Gabung</div>
							<div class="font-size-11 cl-secondary font-weight-500">{{ detailSerialMembership.member_join_datetime | tanggal }}</div>
						</v-col>
						<v-col cols="12" sm="6" class="pb-1">
							<div class="font-size-10 cl-grey">Serial Digunakan</div>
							<div class="font-size-11 cl-secondary font-weight-500">{{ detailSerialMembership.serial_used_datetime | tanggal }}</div>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
		...mapState('serial', ['detailSerialMembership']),
	},
	props: {
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>